<template>
  <v-sheet>
    <v-card
        outlined
        tile
    >
      <v-img
          :src="courseRun.course.imageRef"
          class="white--text align-end">
      </v-img>

      <v-card-subtitle v-if="courseRun.isSuccess" class="pb-0">
        Absolviert am {{ courseRun.courseRunDetails.successDate | moment("DD.MM.YYYY HH:mm") }}
      </v-card-subtitle>
      <v-card-subtitle v-else-if="courseRun.isError" class="pb-0">
        Durchgefallen am {{ courseRun.courseRunDetails.failureDate | moment("DD.MM.YYYY HH:mm") }}
      </v-card-subtitle>
      <v-card-subtitle v-else-if="courseRun.courseRunDetails.startDate" class="pb-0">
        Gestartet am {{ courseRun.courseRunDetails.startDate | moment("DD.MM.YYYY HH:mm") }}
      </v-card-subtitle>
      <v-card-title style="word-break: break-word">{{ courseRun.course.title }}</v-card-title>
      <v-card-subtitle v-if="courseRun.isCompound" style="word-break: break-word">Mehrteilig</v-card-subtitle>
      <v-card-actions>
        <v-btn
            v-if="courseRun.course.id!=='61cc5b61cb13df12c18d3ea6' && courseRun.course.id!=='61f95f9bcb13df12c113f391'"
            color="blue" text @click="run(courseRun)">
          Kurs öffnen
        </v-btn>
        <v-btn v-if="courseRun.isSuccess && courseRun.courseRunDetails.certificateDownloadAllowed" color="blue" text @click="download(courseRun)">
          Zertifikat Download
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>

<script>

import CourseRun from "@/models/CourseRun";
import Course from "@/components/sites/Course.vue";

export default {
  components: {Course},
  name: "CourseOverview",
  props: {
    courseRun: {
      type: CourseRun
    }
  },
  methods: {
    download(courseRun) {
      this.$httpDownloadApi.download(courseRun.courseRunDetails.certificateLink, "Zertifikat");
    },
    run(courseRun) {
      this.$emit("run", courseRun);
    }
  }
}
</script>

<style scoped>

</style>
